import { render, staticRenderFns } from "./AutomaticPaymentEditForm.vue?vue&type=template&id=285000ab&scoped=true&"
import script from "./AutomaticPaymentEditForm.vue?vue&type=script&lang=ts&"
export * from "./AutomaticPaymentEditForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "285000ab",
  null
  
)

export default component.exports